var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',[_vm._v("\n    This page does not exist.\n  ")]),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("Go to login page")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }